const IssueTypeDescEnum = Object.freeze({
  1: 'Problem techniczny',
  2: 'Pomysł / usprawnienie',
  0: 'Inne'
});

export default IssueTypeDescEnum;
